import ItemImage from '@/components/elements/images/ItemImage';

const CheckItem = ({ text }: { text: string }) => {
  return (
    <div className="gap-md text-m flex items-center">
      <ItemImage icon="check" size="sm" className="flex-shrink-0" />
      <span>{text}</span>
    </div>
  );
};

export default CheckItem;
